import React, { useState } from 'react';
import { Rocket, Shield, Clock } from 'lucide-react';
import EmailForm from './EmailForm';
import SuccessMessage from './SuccessMessage';

const CTA = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  return (
    <section className="py-20 bg-gradient-to-br from-gray-900 via-blue-900 to-indigo-900 text-white relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 left-20 w-64 h-64 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-indigo-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-pulse delay-1000"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
          Ready to never forget
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-indigo-400">
            another connection?
          </span>
        </h2>
        
        <p className="text-xl text-gray-300 mb-12 leading-relaxed max-w-2xl mx-auto">
          Join thousands of professionals who are already building stronger networks. 
          Get early access to ContaX and transform the way you network forever.
        </p>

        {!showSuccess && (
          <div className="max-w-md mx-auto mb-12">
            <EmailForm onSuccess={() => setShowSuccess(true)} darkMode />
          </div>
        )}

        {showSuccess && (
          <div className="max-w-md mx-auto mb-12">
            <SuccessMessage darkMode />
          </div>
        )}

        <div className="grid md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-blue-500/20 rounded-full flex items-center justify-center mb-4">
              <Rocket className="w-6 h-6 text-blue-400" />
            </div>
            <h3 className="font-semibold mb-2">Early Access</h3>
            <p className="text-gray-400 text-sm">Be among the first to experience ContaX</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mb-4">
              <Shield className="w-6 h-6 text-green-400" />
            </div>
            <h3 className="font-semibold mb-2">Lifetime Benefits</h3>
            <p className="text-gray-400 text-sm">Special pricing and premium features for early adopters</p>
          </div>

          <div className="flex flex-col items-center">
            <div className="w-12 h-12 bg-purple-500/20 rounded-full flex items-center justify-center mb-4">
              <Clock className="w-6 h-6 text-purple-400" />
            </div>
            <h3 className="font-semibold mb-2">Coming Soon</h3>
            <p className="text-gray-400 text-sm">Expected launch in Q4 2025</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;